import React from 'react';
import { useRouterContext, useRouterType, useLink } from '@refinedev/core';
import type { RefineLayoutThemedTitleProps } from '@refinedev/antd';
import AppIcon from '../../Assets/AppIcon';

export const ThemedTitleV2: React.FC<RefineLayoutThemedTitleProps> = () => {
  const routerType = useRouterType();
  const Link = useLink();
  const { Link: LegacyLink } = useRouterContext();

  const ActiveLink = routerType === 'legacy' ? LegacyLink : Link;

  return (
    <ActiveLink to="/">
      <AppIcon />
    </ActiveLink>
  );
};
